"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProfileServiceBase = void 0;
const hooks_1 = require("../../hooks");
const useProfileServiceBase = (repository) => {
    const { call: getProfileCall, data: profileData, isError: isProfileError, isLoading: isProfileLoading, isSuccess: isProfileSuccess, reset: resetProfile, } = (0, hooks_1.useAsyncStateInfo)(repository.getProfile);
    return {
        profileData,
        getProfileCall,
        resetProfile,
        isProfileError,
        isProfileLoading,
        isProfileSuccess,
    };
};
exports.useProfileServiceBase = useProfileServiceBase;
//# sourceMappingURL=useProfileServiceBase.hook.js.map